// Поля, где минус не к месту (площади, сборы, цены, дни): знак не вводится ни с клавиатуры, ни
// вставкой. Отрицательным бывает только остаток культуры, его поле этим не пользуется.
// Сервер тоже отказывает (services/main, helpers/amounts.js): он форме не доверяет.
const SIGN_KEYS = ['-', '+', 'e', 'E'];

// Поле type="number" без этого принимает «-», «+» и «e» (1e5): для сумм они не нужны.
export const blockSign = (event) => {
  if (SIGN_KEYS.includes(event.key)) event.preventDefault();
};

// Вставленное «-5» стирается. Значение меняется прямо в поле: часть полей формы не управляется из
// state (defaultValue), и до них иначе не достать.
export const dropNegative = (event) => {
  if (Number(event.target.value) < 0) event.target.value = '';
};

// Обработчик onChange поля: сначала стираем отрицательное, потом отдаём остальному коду.
export const nonNegativeChange = (handler) => (event) => {
  dropNegative(event);
  handler(event);
};

// inputProps поля: «вниз» стрелкой не уйти ниже нуля, знак с клавиатуры не вводится.
export const NON_NEGATIVE = { min: 0, onKeyDown: blockSign };
